module.exports = __webpack_public_path__ + "img/Frame_9.01cc1461.png";